import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './OnyxDrawer.css';

/**
 * Canonical right drawer chrome. Prefer this over ad-hoc MUI Drawer wrappers.
 */
export function OnyxDrawer({
  open,
  onClose,
  title,
  children,
  actions = null,
  anchor = 'right',
  className = '',
  drawerProps = {},
}) {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      className={['onyx-drawer', className].filter(Boolean).join(' ')}
      data-testid="onyx-drawer"
      {...drawerProps}
    >
      <div className="onyx-drawer__header">
        {title ? (
          <Typography variant="h4" component="h2" className="onyx-drawer__title">
            {title}
          </Typography>
        ) : <span />}
        {onClose ? (
          <IconButton aria-label="Close drawer" onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : null}
      </div>
      <div className="onyx-drawer__body">{children}</div>
      {actions ? <div className="onyx-drawer__actions">{actions}</div> : null}
    </Drawer>
  );
}

OnyxDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  className: PropTypes.string,
  drawerProps: PropTypes.object,
};
